import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31530972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "#fff" }

import { onMounted, ref, watch } from 'vue'
import 'ol/ol.css'
import { Feature, Map, MapBrowserEvent } from 'ol'
import { getRegionById } from '../model/helpers'
import { getExtentByDistrict, getExtentByRegion, getLayersByType, vectorSource } from '../model/layers'
import { hoverDistrict, hoverRegion } from '../model/hovers'
import { fitByExtent, view } from '../model/view'
import { defaultRegionsStyle, defaultStyle, hoverStyle } from '../model/styles'
import { transform } from 'ol/proj'
import { LocationType } from '@/pages/Report'
import { districtList } from '@/shared/consts/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'VectorMap',
  props: {
    type: null,
    locationId: null,
    hoveredId: null
  },
  emits: [
	'hovered-on-feature',
	'clicked-on-feature'
],
  setup(__props: any, { emit }) {

const props = __props as {
	type: LocationType
	locationId?: number
	hoveredId?: number
};





const mapContainer = ref<HTMLDivElement | null>(null)
const map = ref<Map | null>(null)
const selectedList = ref<Feature[] | []>([])
const isLoading = ref(false)

watch(selectedList, (newValue: Feature[]) => {
	if (newValue.length) {
		const locationCode = props.type === 'country'
			? newValue[0].getProperties().federal_districts
			: getRegionById(props.locationId, +newValue[0].getProperties().id).id
		setTooltipTargetById(locationCode)
	}
})

watch(() => props.hoveredId, (newValue: number) => {
	setTooltipTargetById(newValue)

	if (newValue) {
		const allFeatures = vectorSource.getFeatures()

		if (props.type === 'country') {
			selectedList.value = allFeatures.filter(feature => Number(feature.getProperties().federal_districts) === newValue)
		} else if (props.type === 'district') {
			const regionCode = getRegionById(props.locationId, newValue).id
			selectedList.value = [allFeatures.find(feature => Number(feature.getProperties().id) === regionCode)]
		}

		selectedList.value.forEach(region => {
			region.setStyle(hoverStyle)
		})
	} else {
		// Возвращаемся дефолтные стили
		hoverHandler()
	}
})

const tooltip = ref('')
const setTooltipTargetById = (locationId: number) => {
	if (locationId) {
		if (props.type === 'country') {
			const district = districtList[locationId]
			tooltip.value = district.name
			emit('hovered-on-feature', district.id)
		} else if (props.type === 'district') {
			const region = getRegionById(props.locationId, locationId)
			tooltip.value = region.name
			emit('hovered-on-feature', region.id)
		}
	} else {
		tooltip.value = ''
		emit('hovered-on-feature', undefined)
	}
}

function hoverHandler(e?: MapBrowserEvent<UIEvent>) {
	let feature: Feature

	if (selectedList.value !== []) {
		if (props.type === 'country') {
			selectedList.value?.forEach((feature: Feature) => {
				feature.setStyle(defaultStyle(feature))
			})

			selectedList.value = []

			if (e) feature = hoverDistrict(selectedList, this, e)
		} else if (props.type === 'district') {
			selectedList.value?.forEach((feature: Feature) => {
				feature.setStyle(defaultRegionsStyle())
			})

			selectedList.value = []

			if (e) feature = hoverRegion(selectedList, this, e)
		}
	}

	if (mapContainer.value) {
		if (feature) {
			mapContainer.value.style.cursor = 'pointer'
		} else {
			setTooltipTargetById(undefined)
			mapContainer.value.style.cursor = ''
		}
	}
}

function clickHandler(e) {
	this.forEachFeatureAtPixel(e.pixel, (f: Feature) => {
		if (props.type === 'country') {
			const districtId = +f.getProperties().federal_districts
			emit('clicked-on-feature', districtId)
		} else if (props.type === 'district') {
			const regionId = +f.getProperties().id
			const regionsId = getRegionById(props.locationId, regionId).id
			emit('clicked-on-feature', regionsId)
		}
		return true
	})
}

const onLoadEnd = () => {
	if (props.type === 'district') {
		// 4 это номер дальневосточного округа, его надо центровать по другому из-за 180-го меридиана который его режет
		if (props.locationId === 5) {
			view.setCenter(transform([148, 64], 'EPSG:4326', 'EPSG:3857'))
			view.setZoom(3.2)
		} else {
			fitByExtent(getExtentByDistrict(props.locationId), 0)
		}
		// Удаляем все features не относящиеся к округу
		vectorSource.getFeatures().forEach(feature => {
			if (props.locationId !== Number(feature.getProperties().federal_districts)) {
				vectorSource.removeFeature(feature)
			}
		})
	} else if (props.type === 'region') {
		// 87 это номер чукотки, его надо центровать по другому из-за 180-го меридиана который его режет
		if (props.locationId === 87) {
			view.setCenter(transform([173, 66], 'EPSG:4326', 'EPSG:3857'))
			view.setZoom(4.5)
		} else {
			fitByExtent(getExtentByRegion(props.locationId), 0)
		}
		// Удаляем все features не относящиеся к региону
		vectorSource.getFeatures().forEach(feature => {
			if (props.locationId !== Number(feature.getProperties().id)) {
				vectorSource.removeFeature(feature)
			}
		})
	}

	isLoading.value = false
}

const initMap = () => {
	isLoading.value = true
	if (mapContainer.value && props.type) {
		map.value = new Map({
			target: mapContainer.value,
			layers: getLayersByType(props.type),
			view: view,
			controls: [],
			interactions: []
		})

		map.value.on('pointermove', hoverHandler)
		map.value.on('click', clickHandler)
		map.value.on('loadend', onLoadEnd)
	} else setTimeout(initMap, 100)
}

onMounted(initMap)

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tooltip, {
      visible: !!tooltip.value,
      content: tooltip.value,
      effect: "light",
      placement: "top",
      offset: -50,
      "raw-content": "",
      "popper-class": "map-tooltip-name"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "mapContainer",
          ref: mapContainer,
          class: "map-container"
        }, null, 512)
      ]),
      _: 1
    }, 8, ["visible", "content"])
  ])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})